import React, { useContext } from "react";
import ButtonPrimary from "../SharedComponents/ButtonPrimary";
import Header from "../SharedComponents/Header";
import NavBar from "../SharedComponents/Navbar";
import Card from "./Card";
import { useParams, useNavigate } from "react-router-dom";
import Store from "../Store";
// import ReactStars from "react-rating-stars-component";
import StarRatings from "react-star-ratings";
import { ReactComponent as StarIcon } from "../assets/icons/starIcon.svg";
import { ReactComponent as EmptyStarIcon } from "../assets/icons/emptyStarIcon.svg";
import { useTranslation } from "react-i18next";

// import "./style.scss";
import "./style-rtl.scss";
import Rating from "../Rating";
import Modal from "../SharedComponents/Modal";
import GlobalStates from "../../layouts/GlobalStates";
import { GlobalStateContext } from "./../../layouts/GlobalStates";
import useDefaultFeedbackTabRedirect from "../Hooks/useDefaultFeedbackTabRedirect";

export default function Product() {
    const { t, i18n } = useTranslation();
    const navigator = useNavigate();
    useDefaultFeedbackTabRedirect();

    const { id, isIntro } = useParams();
    const { feedbackAppGlobalState } = useContext(GlobalStateContext);
    const [result, setResult] = feedbackAppGlobalState;

    const [more, setMore] = React.useState(false);
    const [descMore, setDescMore] = React.useState(false);
    const [scroll, setScroll] = React.useState(0);
    const [descHeight, setDescHeight] = React.useState();
    const [currentTab, setCurrentTab] = React.useState(1);

    // useSticky([
    //   {
    //     query: ".middle-header",
    //     type: "height",
    //     min: 80,
    //     height: 180
    //   }, {
    //     reference: ".nav-tab",
    //     query: ".navbar-main",
    //     type: "top",
    //     offset: -20,
    //     target: ".name-rate"
    //   }
    // ]);

    const moreHandle = () => {
        // expands features table
        setMore(!more);
    };
    // React.useEffect(()=>{
    //   window.scrollTo(0, 0);
    // }, [currentTab])
    // React.useEffect(()=>{
    //   const scrollHandle = () => {
    //     var scrollTop = (window.pageYOffset !== undefined) ? window.pageYOffset : (document.documentElement || document.body.parentNode || document.body).scrollTop;
    //     console.log(scrollTop)
    //     setScroll(scrollTop);
    //   }
    //   document.addEventListener('scroll', scrollHandle, true);
    //   window.scrollTo(0, 0);
    //   setDescHeight(document.querySelector(".collapse-section")?.offsetHeight);
    //   return ()=>{
    //     document.removeEventListener('scroll', scrollHandle, true);
    //   }

    // }, [])

    const item = result?.ajax?.item;
    const features = item?.features || [];

    return (
        <>
            {isIntro && <Modal />}
            <div className="tab-section">
                {features.length ? (
                    <>
                        <div
                            className="card-section-con"
                            // style={{
                            //     maxHeight: more ? "unset" : 220,
                            //     marginTop:
                            //         scroll > descHeight + 126
                            //             ? descHeight + 126
                            //             : 0,
                            // }}
                        >
                            <div className="card-section">
                                {features
                                    .filter(
                                        (r) =>
                                            !(r.value === "-" || r.value === "")
                                    )
                                    .slice(
                                        0,
                                        more ? features.length : 5
                                    )
                                    .map((r, index) => (
                                        <Card
                                            key={index}
                                            name={r.feature.name}
                                            value={r.value}
                                            type={r.feature.feature_type}
                                            isFixed={!!r.is_fixed}
                                        />
                                    ))}
                            </div>
                        </div>
                        {!more && features.length > 5 && (
                            <button className="more-btn" onClick={moreHandle}>
                                {t("more.label")}
                            </button>
                        )}
                    </>
                ) : (
                    <div className="no-features">{t("no.feature")}</div>
                )}

                {/* <ButtonPrimary
                    btnContent={t("send.Feedback.label")}
                    onClick={() => navigator("/feedback/form/" + id)}
                /> */}
            </div>
        </>
    );
}
